import { MessagingListView, useTitle, PageHeaderMenuItem } from "daymap-react"
import PageHeader from "../../containers/pageheader/pageheader"
import { PageContainer } from "../../components/layout"
import { useLocation, useNavigate } from "react-router-dom"
import { useState, useCallback } from "react"

function Messaging() {
    useTitle("Communication");
    const navigate = useNavigate();
    const location = useLocation();
    const [menuItems, setMenuItems] = useState<PageHeaderMenuItem[] | undefined>();
    const [handleMenuItemClick, setHandleMenuItemClick] = useState<((item: PageHeaderMenuItem) => void) | undefined>();

    const onMenuReady = useCallback((items: PageHeaderMenuItem[] | undefined, handler: (item: PageHeaderMenuItem) => void) => {
        setMenuItems(items);
        setHandleMenuItemClick(() => handler);
    }, []);

    return <>
        <PageHeader 
            title="Communication" 
            menuItems={menuItems} 
            onMenuItemClick={handleMenuItemClick} />
        <MessagingListView  
            onMessageClick={(id) => navigate(`/message/${id}`)}
            onNewMessage={(messageType) => navigate(`/message/new/${messageType}`)}
            locationKey={location.key}
            pageContainer={PageContainer}
            onMenuReady={onMenuReady}
        />
    </>
}

export default Messaging